import BlueDotsBackground from '../BlueDotsBackground';

export default function ContactUs() {
  return (
    <>
      <BlueDotsBackground />
      <section className="relative z-10 px-6 py-24 min-h-screen flex flex-col justify-center">
        <div className="max-w-xl mx-auto w-full text-center">
          <h1 className="text-4xl md:text-5xl font-semibold tracking-tight leading-tight text-white mb-4">
            Contact Us
          </h1>
          <p className="text-lg text-gray-400 font-light mb-10">
            Fill out the form below and we&apos;ll get back to you shortly.
          </p>

          <div className="rounded-2xl overflow-hidden shadow-xl ring-1 ring-gray-700">
            <iframe
              title="Contact Us Form"
              src="https://34685e70.sibforms.com/v2/serve/MUIFALz29cw6C9qCwmgnzjEXlZ68gjqDlH_N_ATkeT0Mx5z0yuvjw50ads-V8Rm6kHzeKHpCOlLmeJ1xX-jsvjLVaJjtBy98NKTgzR0gqz7o42wEKmaJ-JQM9iQMxxn1DQX-8aJuxcbB5DMAz7aEV-EtNB50miiLE9ULaQ_hTDlD3xoEHjo39EGK2yqBaPyVIDci947JQvhuIWJF6Q=="
              frameBorder="0"
              scrolling="no"
              allowFullScreen
              className="w-full"
              style={{ height: '1250px', display: 'block' }}
            />
          </div>
        </div>
      </section>
    </>
  );
}
